import { executeExposedFunction, getExposedFunctionsList } from '~/utils/exposedFunctions';

export default defineNuxtPlugin(() => {
  (window as any).exposedFunctions = {
    execute: executeExposedFunction,
    list: getExposedFunctionsList,
  };
});
